export default "__VITE_ASSET__CLhpYeIg__"